<template>
  <v-container fill-height fluid class="bg">
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="4">
        <img src="../../assets/img/rebase_logo_white.png" class="login-logo" />
        <v-card class="login-card">
          <h3>Login to your account</h3>
          <v-card-text>
            <v-form ref="signinFrm">
              <v-text-field
                class="mb-4"
                label="Email"
                name="email"
                prepend-icon="mdi-account"
                type="email"
                v-model.trim="signin.email"
              ></v-text-field>
              <v-text-field
                label="Password"
                name="password"
                :type="showPassword ? 'text' : 'password'"
                prepend-icon="mdi-lock"
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="togglePasswordVisibility"
                v-model="signin.password"
              ></v-text-field>
              <!-- <v-checkbox
                label="Remember Password"
                v-model="rememberPassword"
              ></v-checkbox> -->
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" @click="loginUser" block>Login</v-btn>
          </v-card-actions>
          <!-- <base-password-reset-modal /> -->
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import gql from "graphql-tag";

export default {
  name: "LoginAndForgot",
  data() {
    return {
      signin: {
        email: "",
        password: "",
      },
      showPassword: false,
      rememberPassword: false,
      errorMsg: "",
    };
  },
  mounted() {
    this.autoLogin();
  },
  methods: {
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },
    async loginUser() {
      if (this.$refs.signinFrm && !this.$refs.signinFrm.validate()) {
        this.$swal("Error", "Validation failed", "error");
        return;
      }
      try {
        const userData = await this.$apollo.mutate({
          mutation: gql`
            mutation ($email: String!, $password: String!) {
              login(email: $email, password: $password) {
                user {
                  id
                  email
                  role
                }
                token
              }
            }
          `,
          variables: {
            email: this.signin.email,
            password: this.signin.password,
          },
        });

        if (userData) {
          this.$token = userData.data.login.token;
          this.$role = userData.data.login.user.role;
          // if (this.rememberPassword) {
          localStorage.setItem("token", this.$token);
          localStorage.setItem("role", this.$role);
          // } else {
          //   sessionStorage.setItem("token", this.$token);
          //   sessionStorage.setItem("role", this.$role);
          // }

          // Redirect the user after successful login
          this.redirectUser(this.$role);
        }
      } catch (e) {
        console.log(`Login Failed ${JSON.stringify(e)}`);
        if (
          e.graphQLErrors &&
          e.graphQLErrors.length > 0 &&
          e.graphQLErrors[0].message === "The password you supplied is invalid!"
        ) {
          this.$swal("Error", "Invalid email or password", "error");
        } else {
          this.$swal("Error", "An error occurred while logging in", "error");
        }
      }
    },

    autoLogin() {
      const token =
        localStorage.getItem("token") || sessionStorage.getItem("token");
      const role =
        localStorage.getItem("role") || sessionStorage.getItem("role");

      if (token && role) {
        this.$token = token;
        this.$role = role;
        this.redirectUser(role);
      }
    },
    redirectUser(role) {
      if (
        ["admin", "broker", "superAdmin", "manager", "vsadmin"].includes(role)
      ) {
        this.$router.push("/admin/dashboard");
      }
    },
  },
};
</script>
<style scoped>
.bg {
  height: 100vh;
  background-image: linear-gradient(
      to right,
      #2c393b 0%,
      #2c393b 40%,
      transparent 33.33%
    ),
    url("../../assets/img/loginBackground.jpeg");
  background-size: 40% 100%, cover;
  background-repeat: no-repeat;
  background-position: left, right;
  border: 5px solid #4ac5b6;
}

.login-card {
  position: absolute;
  right: 80%;
  transform: translateX(50%);
  top: 20%;
  width: 30%;
  padding: 40px;
}

.login-logo {
  position: absolute;
  right: 80%;
  transform: translateX(50%);
  top: 10%;
  width: 15%;
  height: auto;
}
</style>
